import dataroomConfig from '@dataroom/config';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import evercallUrl from '@/evercall/infrastructure/evercallUrl';
import drsUrl from '@/dealroadshow/infrastructure/url/drsUrl';
import allocateUrl from "@/allocate/infrastructure/allocateUrl";
import { ProductAbbreviations } from '@/finsight/domain/Product';
import { RegionAbbreviations } from '@/finsight/domain/Region';

import allocate1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/allocate1.webp';
import allocate2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/allocate2.webp';
import allocate3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/allocate3.webp';

import capedge1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/capedge1.webp';
import capedge2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/capedge2.webp';
import capedge3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/capedge3.webp';

import dealroadshow1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealroadshow1.webp';
import dealroadshow2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealroadshow2.webp';
import dealroadshow3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealroadshow3.webp';

import dealVDR1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealVDR1.webp';
import dealVDR2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealVDR2.webp';
import dealVDR3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/dealVDR3.webp';

import s17g5One from '@/finsight/ui/components/static/Company/OurSolutions/assets/17g5One.webp';
import s17g5Two from '@/finsight/ui/components/static/Company/OurSolutions/assets/17g5Two.webp';
import s17g5Three from '@/finsight/ui/components/static/Company/OurSolutions/assets/17g5Three.webp';

import finsight1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/finsight1.webp';
import finsight2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/finsight2.webp';
import finsight3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/finsight3.webp';

import investorSet1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/investorSet1.webp';
import investorSet2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/investorSet2.webp';
import investorSet3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/investorSet3.webp';

import veriSend1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/veriSend1.webp';
import veriSend2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/veriSend2.webp';
import veriSend3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/veriSend3.webp';

import evercall1 from '@/finsight/ui/components/static/Company/OurSolutions/assets/evercall1.webp';
import evercall2 from '@/finsight/ui/components/static/Company/OurSolutions/assets/evercall2.webp';
import evercall3 from '@/finsight/ui/components/static/Company/OurSolutions/assets/evercall3.webp';

// Links moved to constants for better code readability
const { tenantDealvdr, tenantInvestorSet, tenantVeriSend, tenant17g5 } = dataroomConfig.tenant;
export const DEALVDR_PRICING_LINK = dataroomUrl(tenantDealvdr.code).getSavingsGuaranteeFootnoteUrl();
export const B_AND_I_LINK = `${ finsightWebUrl.getBondsInventoryABSUrl() }?products=${ ProductAbbreviations.ABS }&regions=${ RegionAbbreviations.USOA }`;
export const LOAN_LEVEL_DATA_LINK = finsightWebUrl.getProductLoanLevelUrl();
export const PORTFOLIO_MONITOR = finsightWebUrl.getPortfolioMonitorUrl();
export const STRAT_MARKET_LINK = finsightWebUrl.getProductLoanLevelUrl();
export const NEW_ISSUE_PIPELINE_LINK = finsightWebUrl.getProductPipelineUrl();
export const TRACE_URL = finsightWebUrl.getTraceUrl();
export const LEARN_MORE_DEALROADSHOW = drsUrl.getUrl();
export const LEARN_MORE_DEALVDR = dataroomUrl(tenantDealvdr.code).getUrl();
export const LEARN_MORE_EVERCALL = evercallUrl.getUrl();
export const LEARN_MORE_FINSIGHT = finsightWebUrl.getFeaturesUrl();
export const LEARN_MORE_INVESTOR_SET = dataroomUrl(tenantInvestorSet.code).getHowItWorksUrl();
export const LEARN_MORE_17G5 = dataroomUrl(tenant17g5.code).getUrl();
export const LEARN_MORE_VERISEND = dataroomUrl(tenantVeriSend.code).getUrl();
export const LEARN_MORE_ALLOCATE = allocateUrl.getUrl();

// @todo create tenant capedge and get link from builder
export const EXPLORE_CAPEDGE = 'https://capedge.com';

export const slickConfigDefault = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000
};

export const slickConfigResponsive = {
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  slidesPerRow: 4,
  rows: 2,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesPerRow: 2,
        rows: 3
      }
    },
    {
      breakpoint: 620,
      settings: {
        slidesPerRow: 1,
        rows: 1,
        dots: true
      }
    }
  ]
};

export const slickModuleKeys = {
  DRS_LIVE_VIDEO: 'DRS_LIVE_VIDEO',
  API: 'API',
  BWICS_INVENTORY: 'BWICS_INVENTORY',
  LOAN_LEVEL_DATA: 'LOAN_LEVEL_DATA',
  PORTFOLIO_MONITOR: 'PORTFOLIO_MONITOR',
  STRAT_MAKER: 'STRAT_MAKER',
  ALERTS_15G: 'ALERTS_15G',
  TRACE: 'TRACE'
};

const OUR_SOLUTIONS_IMAGES = {
  ALLOCATE: [
    allocate1,
    allocate2,
    allocate3
  ],
  DEALROADSHOW: [
    dealroadshow1,
    dealroadshow2,
    dealroadshow3
  ],
  DEALVDR: [
    dealVDR1,
    dealVDR2,
    dealVDR3
  ],
  '17G5': [
    s17g5One,
    s17g5Two,
    s17g5Three
  ],
  FINSIGHT: [
    finsight1,
    finsight2,
    finsight3
  ],
  INVESTORSET: [
    investorSet1,
    investorSet2,
    investorSet3
  ],
  EVERCALL: [
    evercall1,
    evercall2,
    evercall3
  ],
  VERISEND: [
    veriSend1,
    veriSend2,
    veriSend3
  ],
  CAPEDGE: [
    capedge1,
    capedge2,
    capedge3
  ]
};

export const getImagesByTenant = ({ code: tenantCode }: { code: string }) => {
  return OUR_SOLUTIONS_IMAGES[tenantCode.toUpperCase()] || [];
};
